export default {
	pageTitle: "Serienanfrage",
	subtitle: "Individuelles Angebot für Grossmengen, Serienteile und Projekte",
	intro: {
		lead: "Zu jedem berechneten Artikel erhalten Sie im Shop sofort ein automatisches Angebot. Für einzelne Teile und kleine Mengen ist das der schnellste Weg, und Sie können jederzeit direkt bestellen.",
		body: "Bei grösseren Stückzahlen und bei Teilen, die Sie immer wieder abrufen, lohnt sich der genauere Blick. Stellen Sie uns eine Serienanfrage: Wir prüfen sie persönlich, beraten Sie und unterbreiten Ihnen ein individuelles Angebot.",
		responseTime: "Antwort in der Regel innerhalb von 1 bis 2 Arbeitstagen",
		turnaroundValue: "1–2",
		turnaroundUnit: "Arbeitstage",
		turnaroundLabel: "bis zu Ihrem Angebot",
	},
	useCases: {
		title: "Wann sich eine Serienanfrage lohnt",
		bulk: {
			title: "Grossmengen",
			text: "Sie benötigen von einem Artikel eine hohe Stückzahl auf einmal.",
		},
		series: {
			title: "Serienproduktion",
			text: "Sie rufen dieselben Teile in festen Losgrössen wiederkehrend ab.",
		},
		automation: {
			title: "Roboterfertigung",
			text: "Viele Teile lassen sich bei unseren Fertigern automatisiert auf Roboteranlagen produzieren. Gerade bei Grossmengen senkt das den Stückpreis deutlich.",
		},
		individual: {
			title: "Individuelle Anfragen",
			text: "Ihr Projekt hat besondere Anforderungen an Termine, Verpackung oder Ausführung.",
		},
	},
	requirement: {
		title: "Voraussetzung: Die Artikel sind bereits bei Blexon",
		text: "Wir können nur Artikel kalkulieren, die Sie hochgeladen haben und die berechnet und bestellbar sind. Für Einzelteile und kleine Mengen bleibt das automatische Angebot im Warenkorb die schnellere Wahl.",
		linkLabel: "Zu meinen Artikeln",
	},
	steps: {
		title: "So läuft es ab",
		step1: {
			title: "Warenkorb zusammenstellen",
			text: "Wählen Sie die Artikel aus und erfassen Sie die Mengen, die Sie einmalig oder wiederkehrend bestellen möchten.",
		},
		step2: {
			title: "Details zur Anfrage angeben",
			text: "Ergänzen Sie, ob Sie einmalig oder wiederkehrend abrufen, dazu Wunschtermine und alles, was wir sonst wissen sollten.",
		},
		step3: {
			title: "Angebot erhalten",
			text: "Wir prüfen Ihre Anfrage persönlich und melden uns innerhalb von 1 bis 2 Arbeitstagen.",
		},
	},
	list: {
		title: "Ihre Anfragen",
		loading: "Anfragen werden geladen …",
	},
	empty: {
		title: "Noch keine Serienanfrage erstellt",
		text: "Stellen Sie Ihre erste Anfrage für Grossmengen, Serienteile oder ein Projekt. Wir schauen sie uns persönlich an.",
		cartSummary: "Ihr Warenkorb enthält {count} Artikel.",
		emptyCartTitle: "Stellen Sie zuerst Ihren Warenkorb zusammen",
		emptyCartText:
			"Eine Serienanfrage geht immer von Ihrem Warenkorb aus. Legen Sie die Artikel mit den gewünschten Mengen hinein. Danach stellen Sie die Anfrage direkt von hier aus.",
		emptyCartButton: "Zu meinen Artikeln",
	},
	createButton: "Anfrage mit aktuellem Warenkorb erstellen",
	createButtonShort: "Neue Anfrage",
	tile: {
		requestNumber: "Anfrage {number}",
		untitled: "Ohne Bezeichnung",
		articleCount: "Artikel",
		totalQuantity: "Stück gesamt",
		recurring: "Wiederkehrender Abruf",
		createdAt: "Erstellt am {date}",
		offerTotal: "Angebotssumme",
		open: "Anfrage öffnen",
	},
	states: {
		submitted: "Eingereicht",
		inReview: "In Prüfung",
		offerAvailable: "Angebot bereit",
		accepted: "Angenommen",
		declined: "Abgelehnt",
		expired: "Abgelaufen",
		unknown: "Unbekannt",
	},
	form: {
		pageTitle: "Neue Serienanfrage",
		subtitle: "Sagen Sie uns, worum es geht. Wir prüfen Ihre Anfrage persönlich.",
		positions: {
			title: "Artikel und Mengen",
			summary:
				"{count} Position, {quantity} Stück gesamt | {count} Positionen, {quantity} Stück gesamt",
			copiedHint:
				"Die Artikel stammen aus Ihrem Warenkorb. Sie können hier Mengen ändern, Positionen entfernen und weitere Artikel hinzufügen, ohne Ihren Warenkorb zu verändern.",
			empty: "Diese Anfrage enthält noch keine Artikel.",
			articleNumber: "Art.-Nr. {id}",
			summaryShort: "{quantity} Stück in der Anfrage",
			quantityLabel: "Menge",
			articleHeader: "Artikel",
			selectAll: "Alle auswählen",
			remove: "Position entfernen",
			add: "Artikel hinzufügen",
			show: "Einblenden",
			hide: "Ausblenden",
		},
		picker: {
			title: "Artikel hinzufügen",
			search: "Artikel suchen",
			loading: "Artikel werden gesucht …",
			empty: "Keine weiteren bestellbaren Artikel gefunden.",
			close: "Fertig",
		},
		orderType: {
			title: "Art der Bestellung",
			oneTime: "Einmalige Bestellung",
			oneTimeHint: "Sie benötigen diese Menge einmalig.",
			recurring: "Wiederkehrende Serie",
			recurringHint: "Sie rufen dieselben Teile mehrfach ab.",
			completionTitle: "In welchem Zeitraum soll der Auftrag fertig sein?",
			completionTitleFirstDelivery:
				"In welchem Zeitraum soll die erste Lieferung fertig sein?",
			completionFrom: "Fertigstellung von",
			completionTo: "Fertigstellung bis",
			callOffTitle: "Wie oft rufen Sie diese Serie voraussichtlich pro Jahr ab?",
			callOffLabel: "Abrufe pro Jahr",
			callOffHint:
				"Eine Schätzung genügt. Sie hilft uns, Losgrössen und Preis sinnvoll zu planen.",
			seriesNotice:
				"Sie erhalten ein Angebot für die erste Serie und einen Richtpreis für die folgenden Serien. Für die Folgeserien wird ein Teuerungsindex berücksichtigt.",
		},
		delivery: {
			title: "Lieferung oder Abholung",
			pickup: "Abholung",
			pickupHint: "Sie holen den Auftrag selbst ab.",
			delivery: "Lieferung",
			deliveryHint: "Wir liefern an eine Ihrer Adressen.",
			addressLabel: "Ort der Lieferung",
			noAddresses: "Für Ihr Konto ist noch keine Lieferadresse hinterlegt.",
			noteLabelDelivery: "Hinweise zur Lieferung",
			noteHint: "Zum Beispiel Teillieferungen, Anlieferzeiten oder Verpackung.",
		},
		inspection: {
			title: "Erstbemusterung",
			explanation:
				"Bei grösseren Mengen empfehlen wir eine Erstbemusterung. Die Kosten sind im Preis des Angebots bereits berücksichtigt. Wird der Auftrag nach der Erstbemusterung nicht erteilt, verrechnen wir die bemusterten Teile zum Preis der Einzelpositionen.",
			wanted: "Erstbemusterung gewünscht",
			notWanted: "Keine Erstbemusterung",
			scopeTitle: "Welche Positionen sollen bemustert werden?",
			allPositions: "Alle Positionen",
			selectedPositions: "Nur ausgewählte Positionen",
			selectHint:
				"Haken Sie die gewünschten Positionen an und geben Sie je Position die Menge für die Erstbemusterung an.",
			columnHeader: "Erstbemusterung",
			quantityLabel: "Menge",
			quantityTooHigh: "Höchstens {max} Stück.",
			noPositions: "Fügen Sie zuerst Artikel hinzu.",
		},
		remarks: {
			title: "Bemerkungen",
			hint: "Alles, was für die Kalkulation wichtig ist.",
		},
		submit: "Anfrage senden",
		cancel: "Abbrechen",
		blockers: {
			positions: "Fügen Sie mindestens einen Artikel hinzu.",
			completionWindow: "Geben Sie an, in welchem Zeitraum der Auftrag fertig sein soll.",
			completionOrder: "Das Datum für die späteste Fertigstellung liegt vor dem frühesten.",
			callOffs: "Geben Sie an, wie oft Sie die Serie pro Jahr abrufen.",
			address: "Wählen Sie den Ort der Lieferung.",
			inspectionPositions: "Wählen Sie mindestens eine Position für die Erstbemusterung aus.",
			inspectionQuantity: "Geben Sie für jede bemusterte Position eine gültige Menge an.",
		},
		prototypeNotice: "Prototyp: Die Anfrage wurde noch nicht übermittelt, das Backend folgt.",
	},
};
